type ValidationError = {
  detail:
    | string
    | {
        loc: string[]
        msg: string
        type: string
      }[]
}

export class HTTPError extends Error {
  status: number
  statusText: string
  data?: ValidationError

  constructor(
    status: number,
    statusText: string,
    data?: any,
    ...params: any[]
  ) {
    // Pass remaining arguments (including vendor specific ones) to parent constructor
    super(...params)

    // Maintains proper stack trace for where our error was thrown (only available on V8)
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, HTTPError)
    }

    this.name = 'HTTPError'

    this.status = status
    this.statusText = statusText
    this.data = data
  }
}
